const OrderPaidUseCase = {
  execute() {
    window.parent.postMessage({ eventName: 'order_paid' }, '*');
  }
};

export default OrderPaidUseCase;
